import * as React from "react";
import { useStaticQuery } from "gatsby";
import "../styles/style.scss";
import CookieConsent from 'react-cookie-consent';
import { Navbar } from "./navbar";
import { Footer } from "./footer";
export var Layout = function Layout(_ref) {
  var children = _ref.children;
  var data = useStaticQuery("3649515864");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Navbar, null), /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, children))), /*#__PURE__*/React.createElement(Footer, null), /*#__PURE__*/React.createElement(CookieConsent, {
    acceptOnScroll: true
  }, "We use cookies to ensure that we give you the best experience on our website. If you continue to use this site we will assume that you are happy with it."));
};